/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Source_Frame_Rate_LabelInputs */



/**
* | output |
* | --- |
* | "Source Framerate" |
*
* @param {Subtitle_Import_Source_Frame_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_source_frame_rate_label = /** @type {((inputs?: Subtitle_Import_Source_Frame_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Source_Frame_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Frequence d'images source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellbildrate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza fotogrammi sorgente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходная частота кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de cuadros de origen")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源帧率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースフレームレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत फ्रेमरेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de quadros da fonte")
	return /** @type {LocalizedString} */ ("Source Framerate")
});